<template>
	<div class="container-fluid">
		<SitemapsTable />

		<ul class="nav nav-tabs">
			<li
				v-for="(tab, index) in tabs"
				class="nav-item"
				@click="selectedTab = tab.name"
				:key="index"
			>
				<a
					:class="[
						'nav-link d-inline-flex gap-2 align-items-center',
						{ active: tab.name === selectedTab },
					]"
					href="#"
				>
					{{ tab.title }}
					<div
						v-if="tab.name === 'resources'"
						class="
							form-check form-switch
							d-flex
							align-items-center
							justify-content-center
							m-0
						"
					>
						<input
							class="form-check-input"
							type="checkbox"
							:checked="watchResources"
							@click.stop="toggleWatchResources()"
							id="check-resources-checkbox"
							title="Check resources"
						/>
					</div>
				</a>
			</li>
		</ul>

		<keep-alive>
			<ResultsTable v-if="selectedTab === 'pages'" />
			<ResourceResultsTable v-else-if="selectedTab === 'resources'" />
			<RegexResultsTable v-else-if="selectedTab === 'regexes'" />
			<HiddenErrorsTable v-else-if="selectedTab === 'hiddenErrors'" />
			<ResponseStatusCodesHelp v-else-if="selectedTab === 'help'" />
		</keep-alive>
	</div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import ResourceResultsTable from "./components/ResourceResultsTable.vue";
import ResultsTable from "./components/ResultsTable.vue";
import RegexResultsTable from "./components/RegexResultsTable.vue";
import SitemapsTable from "./components/SitemapsTable.vue";
import { watcherService } from "./services/watcherService";
import HiddenErrorsTable from "./components/HiddenErrorsTable.vue";
import ResponseStatusCodesHelp from "./components/ResponseStatusCodesHelp.vue";

export default defineComponent({
	name: "App",
	components: {
		SitemapsTable,
		ResultsTable,
		ResourceResultsTable,
		RegexResultsTable,
		HiddenErrorsTable,
		ResponseStatusCodesHelp,
	},
	setup() {
		const tabs = [
			{ name: "pages", title: "Pages" },
			{ name: "resources", title: "Resources" },
			{ name: "regexes", title: "Regexes" },
			{ name: "hiddenErrors", title: "Hidden Errors" },
			{ name: "help", title: "Help" },
		] as const;
		const selectedTab = ref<typeof tabs[number]["name"]>("pages");

		const { watchResources, setWatchResources } = watcherService;
		const toggleWatchResources = () => {
			setWatchResources(!watchResources.value);
		};

		return {
			tabs,
			selectedTab,

			watchResources,
			toggleWatchResources,
		};
	},
});
</script>
